import type { CSSProperties } from "react";

/** Offsets an entrance so a group does not arrive all at once. */
export function delay(ms: number): CSSProperties {
  return { "--delay": `${ms}ms` } as CSSProperties;
}
